import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, withStyles } from '@material-ui/core';
import { Button } from '@orijinworks/frontend-commons';
import styles from './bulk-actions-bar.style';
import ScoreTierLegend from '../score-tier-legend/score-tier-legend';

const BulkActionsBar = ({
  classes,
  selectedCount,
  linkableCount,
  pageLinkableCount,
  pageHighConfidenceCount,
  onBulkLinkSuggestions,
  onSelectAllLinkable,
  onSelectHighConfidence,
  onClearSelection,
  loading,
}) => {
  const hasSelection = selectedCount > 0;

  return (
    <Box
      className={classes.bar}
      display="flex"
      alignItems="center"
      flexWrap="wrap"
      data-testid="lms-course-review-bulk-actions"
    >
      <Box className={classes.legend} data-testid="score-tier-legend">
        <Typography variant="caption" color="textSecondary" className={classes.legendLabel}>
          Match confidence:
        </Typography>
        <ScoreTierLegend />
      </Box>

      {hasSelection ? (
        <>
          <Typography variant="body2" className={classes.summary}>
            {selectedCount} selected
            {linkableCount > 0
              ? ` · ${linkableCount} can be linked using suggestions`
              : ' · none have a suggested match to link'}
          </Typography>
          <Box className={classes.actions}>
            <Button
              color="primary"
              variant="contained"
              size="small"
              disabled={linkableCount === 0 || loading}
              onClick={onBulkLinkSuggestions}
              data-testid="bulk-link-suggestions-btn"
            >
              Link {linkableCount} using suggestions
            </Button>
            <Box marginLeft={1}>
              <Button
                color="default"
                variant="outlined"
                size="small"
                disabled={loading}
                onClick={onClearSelection}
                data-testid="clear-selection-btn"
              >
                Clear selection
              </Button>
            </Box>
          </Box>
        </>
      ) : (
        <>
          <Typography variant="body2" className={classes.hint}>
            Select rows with checkboxes to bulk-link using suggested matches.
            {pageLinkableCount > 0
              ? ` ${pageLinkableCount} on this page have a suggestion`
              : ' No suggestions on this page'}
            {pageHighConfidenceCount > 0
              ? ` (${pageHighConfidenceCount} high confidence ≥90%).`
              : '.'}
          </Typography>
          <Box className={classes.actions}>
            <Button
              color="primary"
              variant="outlined"
              size="small"
              disabled={pageLinkableCount === 0 || loading}
              onClick={onSelectAllLinkable}
              data-testid="select-all-linkable-btn"
            >
              Select all with suggestions
            </Button>
            <Box marginLeft={1}>
              <Button
                color="default"
                variant="outlined"
                size="small"
                disabled={pageHighConfidenceCount === 0 || loading}
                onClick={onSelectHighConfidence}
                data-testid="select-high-confidence-btn"
              >
                Select high confidence (≥90%)
              </Button>
            </Box>
          </Box>
        </>
      )}
    </Box>
  );
};

BulkActionsBar.propTypes = {
  selectedCount: PropTypes.number.isRequired,
  linkableCount: PropTypes.number.isRequired,
  pageLinkableCount: PropTypes.number.isRequired,
  pageHighConfidenceCount: PropTypes.number.isRequired,
  onBulkLinkSuggestions: PropTypes.func.isRequired,
  onSelectAllLinkable: PropTypes.func.isRequired,
  onSelectHighConfidence: PropTypes.func.isRequired,
  onClearSelection: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

BulkActionsBar.defaultProps = {
  loading: false,
};

export default withStyles(styles)(BulkActionsBar);
